<template>
  <div v-if="isTrial && dataLoaded">
    <div
      class="relative flex items-center justify-between overflow-hidden rounded-md bg-gradient-to-r from-green-700 to-green-600 px-8 py-4 shadow-inner"
    >
      <div class="mb-1 mt-2">
        <h3
          v-if="trialDays <= 0"
          class="text-xl font-medium leading-8 tracking-normal text-white md:leading-3"
        >
          Your trial has ended
        </h3>
        <h3
          v-else
          class="text-xl font-medium leading-8 tracking-normal text-white md:leading-3"
        >
          Your trial ends in {{ trialDays }} days
        </h3>
        <p class="text-md mt-2 leading-6 tracking-normal text-gray-100">
          Upgrade to a paid plan to continue using Veridis
        </p>
      </div>
      <div class="z-10">
        <NuxtLink
          to="/contact-us"
          target="_blank"
          class="text-gray focus:shadow-outline-gray rounded-md border border-transparent bg-white px-4 py-2 text-sm font-medium leading-5 shadow-md transition-colors duration-150 hover:bg-gray-200 focus:outline-none active:bg-gray-300"
        >
          Extend trial
        </NuxtLink>
      </div>
      <NuxtImg
        src="/illustration/1.svg"
        class="absolute -top-20 right-20 h-40 w-40"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'TrialBanner',

  data() {
    return {
      trialDays: 0,
      isTrial: true,
      dataLoaded: false,
    }
  },

  created() {
    this.$apis.tiers
      .tenantTiers()
      .then(({ data: [tier] }) => {
        this.trialDays = this.$moment().diff(tier.expires_in, 'days') * -1
        this.isTrial = tier.is_trial
      })
      .finally(() => (this.dataLoaded = true))
  },
}
</script>
